import Error from 'components/error'
import { useEffect, useState } from 'react'
import { amplitudeEvent } from 'lib/amplitude'
import { useAuth } from 'lib/auth'
import { useGuestPrivateBookingEnabled } from '../guest-booking'
import LeadForm from '../../coach-leads/lead-form'
import SelectTimeLayout from './select-time-layout'
import SelectTimeSkeleton from './select-time-skeleton'
import { useMonthlyLessonAvailability } from './utils'

const SelectLessonTime = ({
  currentUrl,
  previousUrl,
  locationId,
  lessonTypeId,
  lessonCreditBalanceQuantity,
  nextExpirationDate,
}) => {
  const { data, loading, error, refetch } = useMonthlyLessonAvailability(
    locationId,
    lessonTypeId,
    true,
  )
  const [showRequestTime, setShowRequestTime] = useState(false)
  const { isLoggedIn } = useAuth()
  const guestBookingEnabled = useGuestPrivateBookingEnabled()

  useEffect(() => {
    amplitudeEvent('start-private-booking', {
      is_guest: !isLoggedIn,
      guest_booking_enabled: guestBookingEnabled,
      lesson_type_id: lessonTypeId,
      location_id: locationId,
    })
    // fire once per page view
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (error) return <Error error={error} />
  if (loading) return <SelectTimeSkeleton />

  const { lessonTypes } = data
  const coach = lessonTypes[0].coach

  if (showRequestTime) {
    return <LeadForm coach={coach} source="MYPGA_SCHEDULE_FULLY_BOOKED" />
  }

  return (
    <SelectTimeLayout
      lessonTypes={lessonTypes}
      currentUrl={currentUrl}
      previousUrl={previousUrl}
      refetch={refetch}
      setShowRequestTime={coach.coachProfile ? setShowRequestTime : false}
      lessonCreditBalanceQuantity={lessonCreditBalanceQuantity}
      nextExpirationDate={nextExpirationDate}
    />
  )
}

export default SelectLessonTime
